module.exports = __webpack_public_path__ + "img/how_to_print_edge.745902b3.png";